import "./home.css";

import React from "react";
import { Link } from "react-router-dom";

import { HOME, ROUTES, SECTIONS } from "../../data/content";
import { LineIcon } from "../general/Icons";
import PageMeta from "../general/PageMeta";
import Gallery from "./Gallery";

//Icon + bold title + grey line (Our Services, Things To Do)
const Feature = ({ icon, title, text }) => (
  <li className={"feature"}>
    <LineIcon
      name={icon}
      className={"feature-icon"}
    />
    <h3 className={"feature-title"}>{title}</h3>
    <p className={"body-text"}>{text}</p>
  </li>
);

//The whole site is this one page, as on Wix - the menu scrolls to each section
const Home = () => {
  const { ABOUT, ROOMS, SERVICES, SEE_DO } = HOME;

  return (
    <React.Fragment>
      <PageMeta
        title={HOME.TITLE}
        isFullTitle
      />

      <section className={"home-intro"}>
        <h1 className={"home-logo"}>
          <img
            src={"/images/logo.webp"}
            alt={"Villa Portia"}
            width={202}
            height={307}
          />
        </h1>
        <div className={"home-hero"}>
          <img
            src={"/images/home/hero.webp"}
            alt={"Bedroom at Villa Portia with a blue velvet headboard"}
            width={2000}
            height={1333}
          />
        </div>
      </section>

      <section
        id={SECTIONS.ABOUT}
        className={"home-about"}
      >
        <div className={"container"}>
          <h2 className={"heading"}>{ABOUT.HEADING}</h2>
          <p className={"body-text home-about-text"}>{ABOUT.TEXT}</p>
        </div>
      </section>

      <section
        id={SECTIONS.ROOMS}
        className={"home-rooms"}
      >
        <div className={"home-rooms-media"}>
          <img
            src={"/images/home/rooms.webp"}
            alt={""}
            width={2000}
            height={1125}
            loading={"lazy"}
          />
        </div>
        <div className={"home-rooms-card"}>
          <h2 className={"heading"}>{ROOMS.HEADING}</h2>
          <p className={"body-text"}>{ROOMS.TEXT}</p>
          <Link
            to={ROUTES.BOOK}
            className={"btn"}
          >
            {ROOMS.BUTTON}
          </Link>
        </div>
      </section>

      <section
        id={SECTIONS.SERVICES}
        className={"home-features"}
      >
        <div className={"container"}>
          <h2 className={"heading"}>{SERVICES.HEADING}</h2>
          <ul className={"feature-grid"}>
            {SERVICES.ITEMS.map((item) => (
              <Feature
                key={item.title}
                {...item}
              />
            ))}
          </ul>
        </div>
      </section>

      <Gallery />

      <section
        id={SECTIONS.SEE_DO}
        className={"home-features is-area"}
      >
        <div className={"container"}>
          <h2 className={"heading"}>{SEE_DO.HEADING}</h2>
          <ul className={"feature-grid is-four"}>
            {SEE_DO.ITEMS.map((item) => (
              <Feature
                key={item.title}
                {...item}
              />
            ))}
          </ul>
        </div>
      </section>

      <div
        className={"photo-strip"}
        style={{ backgroundImage: "url(/images/home/strip.webp)" }}
        role={"img"}
        aria-label={"Bedroom with a blue velvet headboard and bedside lamps"}
      />
    </React.Fragment>
  );
};

export default Home;
